// Componente React "invisibile" che fa scroll in alto ad ogni cambio di route.
// Nota per il prossimo dev: non renderizza nulla, serve solo come effetto collaterale.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): null => {
  const { pathname, search } = useLocation();

    useEffect(() => {
    // Ritarda lo scroll per assicurarti che il DOM sia aggiornato
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
